<h2 mat-dialog-title>Add New Worker Role</h2>

<form [formGroup]="editForm" (ngSubmit)="onEditFormSubmit(editForm.value)">
  <mat-dialog-content>
    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" required>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="fill">
        <mat-label>Description</mat-label>
        <input matInput formControlName="description" required>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!editForm.valid || (operationInProg$ | async)">
      <span *ngIf="!(operationInProg$ | async)">Save</span>
      <mat-spinner *ngIf="operationInProg$ | async" diameter="20"></mat-spinner>
    </button>
  </mat-dialog-actions>
</form> 